module.exports = __webpack_public_path__ + "img/product4.2c8825c5.png";